import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_83j5eoki61: FaireBrandEntity = {
  token: "b_83j5eoki61",
  type: "brand",
  name: "Minted",
  avatarUrl:
    "https://cdn.faire.com/fastly/4b909052bea9a98282b0d9a518b135e2255854da2a1d009753d918a5e93c8fd2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8fc4149e584e62d392abb6c140b373c440c5000c59ae45b2e94528679a9fdc14.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4b909052bea9a98282b0d9a518b135e2255854da2a1d009753d918a5e93c8fd2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8fc4149e584e62d392abb6c140b373c440c5000c59ae45b2e94528679a9fdc14.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Discover unique art, stationery, and home goods designed by a community of independent artists from all 50 U.S. states and more than 120 countries around the globe. Minted manufactures the products on behalf of these artists, ensuring consistent, luxe quality. A portion of every purchase is paid to the independent artist behind the design, supporting creative careers.\n\nEnergized by design-lovers, our community-driven brand is building the future we want to live in. Let’s create it together.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:08.505Z",
    importedBy: "entity-db-cli",
  },
};
